import { environment } from '@environments/environment';
import { AuthConfig } from 'angular-oauth2-oidc';
import { PAGE_ROUTES } from '@shared/core-data';

export const authCodeFlowConfig: AuthConfig = {
  issuer: `${environment.keycloak.oauthServerHost}/realms/${environment.keycloak.oauthRealm}`,
  redirectUri: `${window.location.origin}/${PAGE_ROUTES.CALLBACK}`,
  postLogoutRedirectUri: `${window.location.origin}/${PAGE_ROUTES.WELCOME}`,
  clientId: environment.keycloak.oauthClientId,
  responseType: environment.keycloak.responseType,
  scope: environment.keycloak.scope,
  strictDiscoveryDocumentValidation: false,
  showDebugInformation: !environment.production,
  useSilentRefresh: false,
  disableAtHashCheck: true,
  oidc: true,
  requireHttps: false,
};
